import { comparisonData } from "@/mocks/faq";
import { mainSiteUrl } from "@/mocks/categories";

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            Quick Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            ACBuy Spreadsheet{" "}
            <span className="text-primary-600">vs</span> Traditional Sourcing
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">
            See how the acbuy spreadsheet outperforms conventional sourcing methods across key metrics
          </p>
        </div>

        <div className="max-w-3xl mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-primary-700">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-file-list-3-line text-primary-500"></i>
                    ACBuy Spreadsheet
                  </div>
                </th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-600">Traditional Sourcing</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="border-b border-background-200 hover:bg-background-100/50 transition-colors">
                  <td className="py-3.5 px-5 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-3.5 px-5">
                    <span className="inline-flex items-center gap-1.5 text-sm text-primary-700 font-medium">
                      <i className="ri-check-line text-primary-500 text-xs"></i>
                      {row.acbuy}
                    </span>
                  </td>
                  <td className="py-3.5 px-5 text-sm text-foreground-600">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* CTA under table */}
        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get Access to ACBuy Spreadsheet Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}